import { zip as fflateZip } from 'fflate';

interface PhotoZipItem {
  filename: string;
  blob: Blob;
}

/**
 * @example
 * const zipBlob = await createZipBlob([
 *   { filename: 'photo1_square.jpg', blob: blob1 },
 *   { filename: 'photo2_square.png', blob: blob2 },
 * ]);
 */
export async function createZipBlob(photos: PhotoZipItem[]): Promise<Blob> {
  const photoArrays: Record<string, Uint8Array> = {};

  for (const { filename, blob } of photos) {
    const arrayBuffer = await blob.arrayBuffer();
    photoArrays[filename] = new Uint8Array(arrayBuffer);
  }

  return new Promise((resolve, reject) => {
    fflateZip(
      photoArrays,
      { level: 6 } /* 壓縮等級 0-9；6 兼顧速度與檔案大小 */,
      (err, data) => {
        if (err) {
          reject(new Error(`Failed to create ZIP: ${err.message}`));
        } else {
          resolve(
            new Blob([data as unknown as BlobPart], {
              type: 'application/zip',
            }),
          );
        }
      },
    );
  });
}

/**
 * @example
 * generateZipFilename() // 'photos_square_20260412_143025.zip'
 */
export function generateZipFilename(): string {
  const now = new Date();

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const date = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');

  const timestamp = `${year}${month}${date}_${hours}${minutes}${seconds}`;

  return `photos_square_${timestamp}.zip`;
}
